import { PenLine } from "lucide-react";
import SignaturePad from "@/components/SignaturePad";
import { ROLE_LABELS, fmt } from "@/lib/clinical";

export default function SignaturesSection({ signatures, sigName, setSigName, sigNote, setSigNote, sigData, setSigData, saving, onSave }) {
  return (
    <section className="bg-white rounded-xl border border-slate-200 p-5 sm:p-6" data-testid="refusal-signatures-section">
      <h2 className="font-heading text-lg font-bold text-[#0F2547] flex items-center gap-2 mb-1">
        <PenLine className="h-5 w-5 text-[#ED8B00]" /> Refusal of Medical Treatment
      </h2>
      <p className="text-xs text-slate-500 mb-4">
        If the patient refuses treatment, ask them to sign below. You are recorded as the witness.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-3">
        <input placeholder="Patient's printed name *" value={sigName} onChange={(e) => setSigName(e.target.value)}
          data-testid="refusal-name-input"
          className="h-12 rounded-lg border border-slate-300 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#005EB8]" />
        <input placeholder="Note (optional, e.g. advised to attend A&E)" value={sigNote} onChange={(e) => setSigNote(e.target.value)}
          data-testid="refusal-note-input"
          className="h-12 rounded-lg border border-slate-300 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#005EB8]" />
      </div>
      <SignaturePad key={signatures.length} onSign={setSigData} />
      <div className="flex justify-end mt-3">
        <button onClick={onSave} disabled={saving || !sigData || !sigName.trim()} data-testid="save-refusal-button"
          className="h-12 px-6 rounded-lg bg-[#ED8B00] hover:bg-[#c97600] transition-colors text-white text-sm font-semibold disabled:opacity-50">
          Save refusal form
        </button>
      </div>
      {signatures.length > 0 && (
        <div className="mt-5 space-y-3">
          {signatures.map((s) => (
            <div key={s.id} className="rounded-xl border border-slate-200 p-4" data-testid={`refusal-entry-${s.id}`}>
              <img src={s.signature_data} alt={`Signature of ${s.patient_name}`} className="h-16 bg-white border border-slate-100 rounded" />
              <div className="mt-2 text-[11px] text-slate-500">
                <span className="font-semibold text-[#0F2547]">{s.patient_name}</span> refused treatment
                {s.note && <> — {s.note}</>}
                <span className="block mt-0.5">
                  Witnessed by {s.witnessed_by_name} ({ROLE_LABELS[s.witnessed_by_role] || s.witnessed_by_role}) · {fmt(s.created_at)}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
